<template lang="pug">
  Modal(ref="modal" title="Packages Holding" closable="true")
    .product-details-modal-body.ssp-form-horizontal
      GenericTable
        tr(slot="thead")
          th Id
          th Name
          th Material
          th Count
          th Dry Weigth
          th Max Gross Weight
        tr(v-for="p in packages")
          td {{p.id}}
          td {{p.name}}
          td {{p.material}}
          td {{p.count}}
          td {{p.dryWeight}}
          td {{p.maxGrossWeight}}
    div(slot="footer")
      button.btn.btn-default(@click="$refs.modal.cancel()") Close
</template>

<script>
import Modal from '@/components/common/Modal'
import GenericTable from '@/components/common/GenericTable'

export default {
  data: () => ({
    packages: null
  }),
  methods: {
    open(packages) {
      this.packages = packages.package
      this.$refs.modal.open();
    }
  },
  components: {
    Modal,
    GenericTable
  }
}
</script>

<style lang="scss">
.product-details-modal-body {
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/ProductDetailsModal.vue